/**
 * /v1/wallets/* — 錢包相關
 *
 * 路徑集中在檔頭的 maps 變量；baseURL 走 http.ts 預設（runtimeConfig `API_BASE`）。
 *
 * 注意：401 由 http.ts 統一處理 —— 這是 GET，會「自動續期 + 帶新 token 重發一次」，
 * 呼叫端通常無感；真的救不回來才 reject (ApiError)。詳見 src/api/CLAUDE.md 的 401 段。
 */
import { useHttp, type RequestConfig } from '../http'
import type { BalanceResponse } from './types'

const maps = {
  balance: '/v1/wallets/balance',
} as const

/**
 * 取得當前帳戶餘額
 * GET /v1/wallets/balance
 *
 * @param options.skipAuthRecovery 由**續期流程自己**呼叫時要設 true（authStore.refreshAuth
 *   換到新 token 後會重抓一次餘額）。否則 401 的自動重發會去 await 正在進行中的續期，
 *   而那個續期正在等這支回來 → 死鎖。見 http.ts 的 `skipAuthRecovery`。
 */
export const fetchBalance = (options?: Pick<RequestConfig, 'skipAuthRecovery'>) =>
  // ⚠️ useHttp.get 的簽名是 (url, params, config) —— options 一定要放**第三個**位置。
  //    放第二個會被當成 query string 送出去（型別是 Record<string, unknown>，TS 不會擋），
  //    旗標永遠到不了 401 邏輯。
  useHttp.get<BalanceResponse>(maps.balance, undefined, options)
